import React from 'react';

const Abouthome = () => {
  return (
    <section
      className="about-section"
      style={{ backgroundImage: 'url(/images/resource/1.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="auto-container">
        <div className="content-container">
          {/* Content Column */}
          <div className="content-column">
            <div className="inner-box">
              {/* Section Title */}
              <div className="sec-title">
                <div className="inner-title-box">
                  <h2>
                   OUR GOAL IS TO MAKE SURE <br /> 
YOU HAVE THE BEST EXPERIENCE POSSIBLE
                  </h2>
                  <h4 className="rotate-title">ABOUT US</h4>
                </div>
              </div>

              {/* Text Content */}
              <div className="text">
                <p>
                 As a company, it is vital that you take proper care of your employees when they make company trips. This is because the importance of their trips is equally critical to your company. Our goal at E Travo Corporate Cab & Bus Services is to offer you and your organization with a reliable and affordable chauffeur-driven corporate cab booking services. eTravo Corporate Cab services are always on time and every time, which is tailored to meet the specific needs of your organization. With more than 20+ cities across India, we are always close to your location so that you can reach us as soon as possible. In this way, we are able to provide you with a service that is both excellent and affordable.
                </p>
                <p>
                 In addition, we are able to tailor our services to meet the needs of the organization. We have more than 11 years' experience in arranging car rental services across India for business travellers. We aim to provide you with the most convenient and reliable car rental services in the induSeatery. Cab and bus services in Pune are offered by us, and we are a dependable and affordable company.
                </p>
              </div>

              {/* Button */}
              <a href="/our-fleet" className="book-btn theme-btn btn-style-three">
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Abouthome;
